import { type ClassValue, clsx } from 'clsx'
import { toast } from 'sonner'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs))
}

export const copyToClipboard = async (text: string) => {
	try {
		await navigator.clipboard.writeText(text)
		toast.success('Copied to clipboard')
	} catch {
		toast.error('Failed to copy to clipboard')
	}
}

export function formatBigNumber(
	val: number | string,
	opts: Intl.NumberFormatOptions = { notation: 'compact', maximumFractionDigits: 1 },
	locale = 'en-US',
): string {
	const n = typeof val === 'string' ? Number(val) : val
	if (!Number.isFinite(n)) return String(val)
	return new Intl.NumberFormat(locale, opts).format(n)
}

const dateTimeFormatter = new Intl.DateTimeFormat(undefined, {
	dateStyle: 'medium',
	timeStyle: 'short',
})
export function formatBlockTimestamp(ts: string | number) {
	const n = typeof ts === 'string' ? Number(ts) : ts
	if (!Number.isFinite(n)) return '—'
	// Heuristic: sub-1e12 is seconds, otherwise milliseconds
	const ms = n < 1_000_000_000_000 ? n * 1000 : n
	return dateTimeFormatter.format(new Date(ms))
}

type CatchErrorReturn<T> = [undefined, T] | [Error]

export async function catchError<T>(promise: Promise<T>): Promise<CatchErrorReturn<T>> {
	try {
		const data = await promise
		return [undefined, data] as [undefined, T]
	} catch (error) {
		return [error]
	}
}
